import React from "react";
import Toast from "./toast";

const Notifications = ({notifications}) => {
  return (
    <div className="flex flex-col w-full absolute z-10 mt-3">
      <ul className="list-none p-0 max-w-screen-xl mx-auto w-full pr-6">
        {notifications?.map((notification, index) => (
          <li key={index} className="m-0 pb-2 style-none">
            <Toast {...notification} />
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Notifications;



// WEBPACK FOOTER //
// ./app/javascript/bundles/ui/notifications/index.jsx